export {TnHistoryComponent} from './tn-history.component';
